import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import router from "@/router";
import WindowAdmin from "@/components/WindowAdmin.vue";
import WindowUser from "@/components/WindowUser.vue";
import store from "@/store";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

onMounted(() => {
  axios
    .get("api/v1/currentuser")
    .then((response) => {
      store.commit("setUser", response.data);
    })
    .catch((error) => {
      console.log(error);
      router.push("/");
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).state.user.role == 'admin')
      ? (_openBlock(), _createBlock(WindowAdmin, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(store).state.user.role == 'client')
      ? (_openBlock(), _createBlock(WindowUser, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})